import { Observable } from 'rxjs';

const keyMap = {
  space: 32,
  cmd: 91,
  escape: 27,
  a: 65,
  e: 69,
  f: 70,
  i: 73,
  s: 83,
  z: 90,
  ctrl: 17,
  del: 46,
  backspace: 8,
  enter: 13,
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,
  up:	38,
  down: 40,
  '/': 191,
  period: 190,
};

type mappedKeys = 'space' |
  'cmd' |
  'ctrl' |
  'escape' |
  'a' |
  'f' |
  'i' |
  'z' |
  'del' |
  'backspace' |
  'enter'|
  's' |
  'e' |
  '1' |
  '2' |
  '3' |
  '4' |
  '5' |
  '6' |
  '7' |
  '8' |
  '9' |
  '0' |
  'up'|
  'down' |
  'period' |
  '/';

interface Options {
  ignoreInputEvents?: boolean
}

const isInput = (element: EventTarget | null) => {
  return element &&
         (element as any).tagName === 'INPUT' &&
         (element as any).type === 'text'
};

const keyEvent = (keyCode: number, event: string, {ignoreInputEvents = true}: Options = {}) => Observable.fromEvent(document, event)
  .filter((e: KeyboardEvent) => e.keyCode === keyCode)
  .filter((e: KeyboardEvent) => ignoreInputEvents ? !isInput(e.target) : true)
  .do((e: KeyboardEvent) => e.preventDefault());

const keyDown = (keyCode: number, options?: Options) => keyEvent(keyCode, 'keydown', options);
const keyUp = (keyCode: number, options?: Options) => keyEvent(keyCode, 'keyup', options);

export function keyDownSteam(key: mappedKeys, options?: Options) {
  return keyDown(keyMap[key], options).map(() => key);
}

export function keyUpStream(key: mappedKeys, options?: Options) {
  return keyUp(keyMap[key], options).map(() => key);
}

export function keyComboStream(modifierKey: mappedKeys | mappedKeys[], withKey: mappedKeys) {
  const keyCombo = (modifierKeyCode: number, withKeyCode: number) =>
    keyDown(modifierKeyCode).flatMap(() => {
      return keyDown(withKeyCode).takeUntil(keyUp(modifierKeyCode));
    });

  return Array.isArray(modifierKey) ?
    Observable.merge(...modifierKey.map((modifier) => keyCombo(keyMap[modifier], keyMap[withKey]))) :
    keyCombo(keyMap[modifierKey], keyMap[withKey]);
}



// WEBPACK FOOTER //
// ./src/key-binding-helpers.tsx